import React from 'react'
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogTitle from '@mui/material/DialogTitle';
import Button from '@mui/material/Button';
import { DialogContentText } from '@mui/material';


const ReleaseNoteModal = ({open,onClose,description,heading=''}) => {
    return (
        <Dialog fullWidth maxWidth="sm" open={open} onClose={onClose}>
            <DialogTitle>{heading ? heading : 'Release Notes' } </DialogTitle>
            <DialogContent>
                <DialogContentText>
                    {description}
                </DialogContentText>
            </DialogContent>
            <DialogActions>
                <Button variant="contained"
            size="medium"
            color="error" onClick={onClose}>Close</Button>
            </DialogActions>
        </Dialog>
    )
}

export default ReleaseNoteModal
